import styles from "./SideMenu.module.scss";
import cmsFactory from '../cmsFactory';
import htmlStringToReactNodes from '../../helpers/htmlStringToReactNodes';
const SideMenu = ({
  data: {
    name,
    bodyHTML
  }
}) => <aside className={`row-container ${styles["side-menu"]}`} data-sentry-component="SideMenu" data-sentry-source-file="SideMenu.jsx">
    <h4>{name}</h4>
    {htmlStringToReactNodes(bodyHTML)}
  </aside>;
export default cmsFactory(SideMenu, '/content/singletons/sideMenu.json');